export class BaseElement extends HTMLElement {
  constructor(...args) {
    super(...args)
  }

  lang() {
    return document.documentElement.lang || 'en'
  }

  getArrayAttribute(attr) {
    const attrValue = this.getAttribute(attr) || []
    const result =
      typeof attrValue === 'string'
        ? attrValue
            .split(/[, ]/)
            .map((s) => s.trim())
            .filter((s) => !!s)
        : Array.from(attrValue)
    if (Array.isArray(result)) {
      return result
    }
    throw new Error(`The attribute ${attr} has to be an array.`)
  }

  requiredAttribute(attribute) {
    const attributeValue = this.getAttribute(attribute)
    if (!attributeValue) {
      throw new Error(`The "${attribute}" attribute is required`)
    }
    return attributeValue
  }

  optionalAttribute(attribute, defaultValue = '') {
    return this.getAttribute(attribute) || defaultValue
  }
}
